import React, { useEffect, useState } from 'react'
import Skycons from 'react-skycons'




const CityWeatherInfoComp = (props) => {

    function isAndriod(){
        return navigator.userAgent.toLowerCase().indexOf("android") > -1;
    } 

    function updateWeatherIcon(response){

        let skyconsOptions = {
            "color" : "white"
        }

        if(isAndriod()){
            skyconsOptions.resizeClear = true;
        }

        var skycons = new Skycons(skyconsOptions);
        skycons.set("weather_icon", response.currently.icon);
        skycons.play();
    }

    return (
        <div>

            <div id="weather_infobox" className="weather-info">
                
                <div id="weather_location" className="weather-info__location">{props.locationData.name}</div>
                
                <div className="weather-info__icon">
                    {/* <canvas id="weather_icon" width="128" height="128"></canvas> */}
                    <Skycons 
                        color='white' 
                        icon={props.weatherInfo.icon}
                        autoplay={true}/>
                </div>
                
                <div className="weather-info__temperature">
                    <span id="weather_temp">{props.weatherInfo.temperature}</span> 
                    <span>&#8451;</span>
                </div>
                
                <div id="weather_description" className="weather-info__description">{props.weatherInfo.summary}</div>
                
            </div>
        </div>
    )
}

export default CityWeatherInfoComp;